import React, { useEffect } from 'react';

import { getIndependantProviderRoles } from './utils';
import type { CurrentUser, SelectOption } from '~/types/roles';
import SelectDropdown from '~/ui/3dbiaUI/SelectDropdown';
import BiaSelect from '~/ui/3dbiaUI/BiaSelect/BiaSelect';


interface OrgNamesProps {
  user: CurrentUser;
  organization: string | undefined;
  onOrgClick: (orgName: string) => void;
}

const OrgNames: React.FC<OrgNamesProps> = ({ 
  user, 
  organization, 
  onOrgClick 
}) => {
  const orgNames: string[] = [];
  
  if (
    user &&
    user.userOrganizationRoles &&
    user.userOrganizationRoles.length
  ) {
    user.userOrganizationRoles.forEach(role => {
      if (!orgNames.includes(role.org_name)) orgNames.push(role.org_name);
    });

    useEffect(() => {
      if (orgNames.length === 1) onOrgClick(orgNames[0]);
    }, [orgNames.length]);

    // if (getIndependantProviderRoles(user).length) orgNames.push('None');
    
    const options: SelectOption[] = orgNames.map(orgName => ({
      id: orgName,
      name: orgName,
    }));

    return (
      <BiaSelect
        placeHolder='Select Organization'
        className={`large ${orgNames.length <= 1 ? 'disabled' : ''}`}
        labelClass='d-none'
        value={organization}
        options={options}
        onChange={(orgName: SelectOption['id']) => onOrgClick(orgName as string)}
      />
    );
  }
  return null;
};

export default OrgNames;
